module.exports = __webpack_public_path__ + "media/xp-speaking.813590d1.mp4";